import { api } from '@upryzze/services';

// Console "Request a change" (doc 28 W14). Each request becomes a task for
// the UpRyzze team; the list shows its status.
export const listContentRequests = () => api.get('/v2/content-requests');

export const createContentRequest = (body) =>
  api.post('/v2/content-requests', body);
